<template>
  <div class="menuBody" >
  <ReportTree @ReportTreeS="getMsgFormSon"/>
  <AnnualSummaryDialog ref="AnnualSummaryDialog" />
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                实收年度汇总列表 <!--  收费报表管理--实收年度汇总列表  -->
            <div style="float:right;margin-right:10px;margin-top:-10px">
               <el-button type="primary"  size="small" plain style="background: #246CE5;color:#fff;border-radius:9px;display:none" @click="Derive()">导出</el-button>
            </div>
            <div style="float:right;margin-right:10px;margin-top:-10px">
                <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;"  v-Jurisdiction="'expense:web:cr:annualSummary:annualSummaryList'"  @click="Create()">生成报表</el-button>
            </div>
            </div>
                        <div style="width:170px;float:left;margin-bottom:10px">
                <el-select  clearable v-model="value" placeholder="请选择收费项目"  size="small" @change="InvoiceTy(value)">
                    <el-option v-for="item in ChargeItemList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
                          <div style="width:150px;float:left;margin-left:40px;">
              <el-cascader size="small"  :options="HouseNatureList" :props="propss" collapse-tags clearable 
                  @change="ChanHouseNature" placeholder="请选择房屋性质"></el-cascader>
            </div>
               <div style="width:200px;float:left;margin-left:60px">
                  <el-select  clearable  v-model="ReceiptWayval" multiple
                    size="small"
                    collapse-tags
                    @change="receiptChange"
                    placeholder="请选择收款方式">
                    <el-option
                    v-for="item in receiptType"
                    :key="item.receiptTypevalue"
                    :label="item.receiptTypelabel"
                    :value="item.receiptTypevalue"
                    >
                    </el-option>
                </el-select>
            </div>
              <div style="width:220px;float:left;margin-left:10px">
                   <el-date-picker
                      size="small"
                      style="width:220px;float:left;"
                      v-model="DateTime"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="BillDateTime()">
                    </el-date-picker>
              </div>

             <el-table tooltip-effect="light"    v-loading="loading"
      border   :data="tableData"  @cell-click="CellClick" class="TableEl" show-summary style="overflow-y: scroll;float:right" row-key="id"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
            <el-table-column show-overflow-tooltip prop="projectName" label="管理处"  ></el-table-column>
            <el-table-column v-for="(item, index) in display"
                            :key="index"
                            :prop="item.name"
                            :label="item.name">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="HJ" label="合计"  ></el-table-column>
        </el-table>


        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import ReportTree from "./ReportTree.vue";
import AnnualSummaryDialog from "./AnnualSummaryDialog.vue";
export default {
  name: "AnnualSummary",
  components: {ReportTree,AnnualSummaryDialog},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:3,//每页的数据条数
        currentPage:1,//默认开始页面
        diaLogVisible: false,
        AllData:"",
        DateTime:"",
        paymentTy:"",
        roomId:"",
        ownerName:"",
        riseName:"",
        runningName:"",
        
        invoiceType:[{
          value:"2",
          label:"开票中",
        },
        {
          value:"3",
          label:"开票失败",
        },
        {
          value:"4",
          label:"开票成功",
        },{
          value:"5",
          label:"封账待开",
        }],
        value:"",
        valueS:"",
        valueT:"",
        tableData:[],
        coplistArr:[],
        melistArr:[],
        DayCollectArr:[],
        list: [],
        listLoading: true,
        dynamicValidateForm: {
          domains: []
        },
        display:[],
        AllDataCture:[],
        projectIds:[],
        fromDate:"",
        toDate:"",
        ChargeItemList:[],
        payMethods:[],
        receiptType:[],
        ReceiptWayval:"",
        HouseNatureList:[],
        HouseArr:[],
        propss:{multiple: true},
        RoomNature:[],
        KTiN:[],
    }
  },
  methods: {
    CellClick(row, column, cell, event){
      if(column.label == "合计"){
        let obj = {
        "projectId":row.projectId,
        "payMethods":this.payMethods,
        "feeCodes":this.KTiN,
        "roomPros":this.RoomNature,
        "startSkrq":this.fromDate,
        "endSkrq":this.toDate,
        "zjCny":"",
      }
      this.$http.post("/charge/web/report/detailed",obj).then((res) => {
        let data = res.data.data
        // console.log(data)
        if(res.data.code == 200){
          if(data== null  || data== [] || data== undefined){
              this.$message({
                message: '暂无数据',
                type: 'warning'
              });
          }else{
            this.$refs.AnnualSummaryDialog.dialogVisible = true
            this.$refs.AnnualSummaryDialog.title = "统计详细信息"
            this.$refs.AnnualSummaryDialog.tableData = data
          }
        }else{
            this.$message({
                message: res.data.msg,
                type: 'warning'
            });
        }
          
        })
      }else{
       let obj = {
        "projectId":row.projectId,
        "payMethods":this.payMethods,
        "feeCodes":this.KTiN,
        "roomPros":this.RoomNature,
        "startSkrq":this.fromDate,
        "endSkrq":this.toDate,
        "zjCny":column.label,
      }
      this.$http.post("/charge/web/report/detailed",obj).then((res) => {
        let data = res.data.data
        // console.log(data)
        if(res.data.code == 200){
          if(data== null  || data== [] || data== undefined){
              this.$message({
                message: '暂无数据',
                type: 'warning'
              });
          }else{
            this.$refs.AnnualSummaryDialog.dialogVisible = true
            this.$refs.AnnualSummaryDialog.title = "统计详细信息"
            this.$refs.AnnualSummaryDialog.tableData = data
          }
        }else{
            this.$message({
                message: res.data.msg,
                type: 'warning'
            });
        }
          
        })
      }
    },
    BillDateTime(){
            var d = this.DateTime[0]
      	let year = d.getFullYear();
	    	let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1 ): d.getMonth() + 1
	    	let dates = d.getDate()< 10 ? '0' +d.getDate() : d.getDate()
       var ds = this.DateTime[1]
      	let years = ds.getFullYear();
	    	let months = ds.getMonth() + 1 < 10 ? '0' + (ds.getMonth() + 1 ): ds.getMonth() + 1
	    	let datess = ds.getDate()< 10 ? '0' +ds.getDate() : ds.getDate()
      this.fromDate = year+"-"+month+"-"+dates
      this.toDate = years+"-"+months+"-"+datess
    },
    receiptChange(){
      let arr = []
      for(let val of this.receiptType){
        for(let res of this.ReceiptWayval){
           if(val.receiptTypevalue == res){
             arr.push(val.receiptTypelabel)
           }
        }
      }
      this.payMethods = arr
    },
      RECEIPT(){
        this.$http.get("/charge/web/chargeMethod/selectList").then((res) => {
          let date = res.data.data
          let arr = []
          for(let val of date){
            let obj = {
              "receiptTypevalue":val.id,
              "receiptTypelabel":val.methodName,
            }
            arr.push(obj)
          }
          this.receiptType = arr
        })
      },
    InvoiceTy(val){
      // console.log(val,"val")
      let arr = []
      arr.push(val)
      this.KTiN =arr
    },
  
    Create(){
        // 生成
        this.loading = true
        this.ShareList()
    },
     getMsgFormSon(data){
       let arr = []
       for(let val of data){
         arr.push(val.id)
       }
       this.unique(arr)
       this.projectIds = arr

    },
        unique(arr){            
        for(var i=0; i<arr.length; i++){
            for(var j=i+1; j<arr.length; j++){
                if(arr[i]==arr[j]){         //第一个等同于第二个，splice方法删除第二个
                    arr.splice(j,1);
                    j--;
                }
            }
        }
return arr;
},
         ChanHouseNature(val){
        let arr =[]
        for(let res of val){
          arr.push(res[0])
        }
        // 选择房屋性质
        this.RoomNature = arr

      },
    ShareList(){
     let obj = {
            "projectIds":this.projectIds,
            "startSkrq": this.fromDate,
            "endSkrq": this.toDate,
            "feeCodes": this.KTiN,
            "payMethods":this.payMethods,
            "roomPros": this.RoomNature,
 }     
 this.$http.post(this.$requestUrl.POST_ANNUAL_LIST,obj).then((res) => {
    let data = res.data.data
         if(data== null  || data== [] || data== undefined){
          this.$message({
                message: '暂无数据',
                type: 'warning'
              });
              this.loading = false
        }else{
          let data = res.data.data
          let arr = []
          let arrS = []
          let arrT = []
          for(let val of data){
            let obj = {}
            obj.projectName = val.projectName
            obj.projectId = val.projectId
            arr.push(obj)
            for(var i=0; i<arr.length; i++){
              for(var j=i+1; j<arr.length; j++){
                  if(arr[i].projectId==arr[j].projectId){
                      arr.splice(j,1);
                      j--;
                  }
              }
            }
          }
          let sumList = data[0].sumsList
          for(var i in sumList){
            for(let val of arr){
              if(val.projectId === i){
                val.HJ = sumList[i]
              }
            }
          }
          for(let val of data){
            let obj = {
              "name":val.zjCny
            }
            arrT.push(obj)
            arrS.push(val.zjCny)
          }
            for(var i=0; i<arrT.length; i++){
              for(var j=i+1; j<arrT.length; j++){
                  if(arrT[i].name==arrT[j].name){
                      arrT.splice(j,1);
                      j--;
                  }
              }
            }
          this.unique(arrS)
          this.display = arrT
          for(var i=0; i<arrS.length; i++){
            for(let vla of arr){
                vla[arrS[i]] = ""
            }
          }
          for(let i = 0 ;i<data.length;i++){
            for(let val of arr){
              for(let j in val){
                if(data[i].projectId == val.projectId){
                  if(data[i].zjCny == j){
                    val[j] = data[i].zjJe
                  }
                }
              }
            }
          }
          for(let val of arr){
            for(let i in val){
              if(val[i].length === 0){ val[i] = 0 }
            }
          }
            this.tableData = arr
            this.loading = false
        }
        }).catch(() => {
          this.loading = false
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    }, 
    unique(arr){            
        for(var i=0; i<arr.length; i++){
            for(var j=i+1; j<arr.length; j++){
                if(arr[i]==arr[j]){         //第一个等同于第二个，splice方法删除第二个
                    arr.splice(j,1);
                    j--;
                }
            }
        }
return arr;
},
    NodeData(data){
        this.mangroupId = data.value
        this.mangrouplab = data.label
    },
     ChargeItem(){
        this.$http.get(this.$requestUrl.GET_ITEM_WEIGHT).then((res)=>{
            let arr = []
            for(let val of res.data.data){
                if(val.feeCategory == "01"){
                    let obj = {
                        "value":val.feeCode,
                        "label":val.feeName,
                    }
                    arr.push(obj)
                }
                this.ChargeItemList = arr
            }
        })
    },
       HouseNature(){
        let obj = {
            "page":1,
            "size":30,
            "type":"room_property"
        }
         this.$http.post("/sys/web/dict/get/list",obj).then((res)=>{
            let arr = []
            this.HouseArr = res.data.data.records
            for(let val of res.data.data.records){
                    let obj = {
                        "value":val.id,
                        "label":val.label,
                    }
                    arr.push(obj)
            }
             this.HouseNatureList = arr
        })
    },










  },
  mounted() {
    this.RECEIPT()
    this.ChargeItem()
    this.HouseNature()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
.el-cascader-node__label{
  color: black;
}
.TableEl{
    -moz-user-select: none;
-o-user-select:none;
-khtml-user-select:none;
-webkit-user-select:none;
-ms-user-select:none;
user-select:none;
}
</style>